import React from 'react';
import { CreditCard, Smartphone, DollarSign, Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function DonationMethods() {
  return (
    <section className="py-16 px-8 bg-accessible-gray-50 dark:bg-accessible-gray-800 high-contrast:bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="section-title mb-4">
            Wesprzyj nasze działania
          </h2>
          <p className="body-large max-w-3xl mx-auto">
            Wybierz najwygodniejszą dla Ciebie metodę wpłaty i pomóż nam ratować bezdomne zwierzęta
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {/* One-time Donation */}
          <div className="bg-white dark:bg-accessible-gray-700 high-contrast:bg-black p-8 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-300">
            <div className="w-16 h-16 bg-accessible-red-600/10 rounded-full flex items-center justify-center mb-6">
              <CreditCard className="w-8 h-8 text-accessible-red-600" aria-hidden="true" />
            </div>
            <h3 className="heading-4 text-accessible-gray-900 dark:text-white high-contrast:text-white mb-3">
              Wpłata jednorazowa
            </h3>
            <p className="body-medium text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white mb-6">
              Szybki przelew, BLIK lub PayPal. Nawet niewielka kwota ma znaczenie!
            </p>
            <Link
              to="/wplata-jednorazowa"
              className="inline-flex items-center gap-2 link-primary group"
            >
              <span>Wpłać teraz</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
            </Link>
          </div>
          
          {/* Regular Support */}
          <div className="bg-white dark:bg-accessible-gray-700 high-contrast:bg-black p-8 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-300">
            <div className="w-16 h-16 bg-accessible-red-600/10 rounded-full flex items-center justify-center mb-6">
              <Calendar className="w-8 h-8 text-accessible-red-600" aria-hidden="true" />
            </div>
            <h3 className="heading-4 text-accessible-gray-900 dark:text-white high-contrast:text-white mb-3">
              Regularne wsparcie
            </h3>
            <p className="body-medium text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white mb-6">
              Zostań stałym darczyńcą i wspieraj nas regularnie. Pomóż nam planować długoterminowo.
            </p>
            <Link
              to="/wsparcie"
              className="inline-flex items-center gap-2 link-primary group"
            >
              <span>Zostań stałym darczyńcą</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
            </Link>
          </div>
          
          {/* Tax Donation */}
          <div className="bg-white dark:bg-accessible-gray-700 high-contrast:bg-black p-8 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-300">
            <div className="w-16 h-16 bg-accessible-red-600/10 rounded-full flex items-center justify-center mb-6">
              <DollarSign className="w-8 h-8 text-accessible-red-600" aria-hidden="true" />
            </div>
            <h3 className="heading-4 text-accessible-gray-900 dark:text-white high-contrast:text-white mb-3">
              Przekaż 1.5% podatku
            </h3>
            <p className="body-medium text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white mb-6">
              To nic Cię nie kosztuje, a dla nas znaczy bardzo wiele. KRS: 0000437387
            </p>
            <Link
              to="/przekaz-podatek"
              className="inline-flex items-center gap-2 link-primary group"
            >
              <span>Dowiedz się więcej</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
            </Link>
          </div>
        </div>
        
        <div className="text-center">
          <Link
            to="/wsparcie"
            className="inline-flex items-center gap-2 bg-accessible-red-600 text-white px-8 py-4 rounded-lg hover:bg-accessible-red-700 transition-colors btn-text-large"
          >
            <span>ZOBACZ WSZYSTKIE FORMY WSPARCIA</span>
            <ArrowRight className="w-5 h-5" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}